import { Slot as SlotPrimitive } from "radix-ui"
export const Slot = SlotPrimitive.Slot
